import { CartTypeEnum } from "@lib/enum"
import dayjs from "dayjs"

export class CartDetailModel {
  id: any
  name?: string
  project?: any
  code?: string
  description?: string
  uniqueId?: string
  approvalType?: number
  salesPolicies?: any[]
  type?: CartTypeEnum
  projectId?: number
  startShowCart?: string
  endShowCart?: string
  startBooking?: string
  endBooking?: string

  constructor() {
    this.id = undefined
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new CartDetailModel(), obj)

    newObj.startBooking = obj.startBooking ? dayjs(obj.startBooking) : null
    newObj.endBooking = obj.endBooking ? dayjs(obj.endBooking) : null
    newObj.depositDeadline = obj.depositDeadline
      ? dayjs(obj.depositDeadline)
      : null
    newObj.depositDeadlineForBooking = obj.depositDeadlineForBooking
      ? dayjs(obj.depositDeadlineForBooking)
      : null
    newObj.confirmDeadline = obj.confirmDeadline
      ? dayjs(obj.confirmDeadline)
      : null
    newObj.sPADepositDeadline = obj.spaDepositDeadline
      ? dayjs(obj.spaDepositDeadline)
      : null

    return newObj
  }

  public static assigns(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}

export class CartUpdateModel {
  id: any
  constructor() {
    this.id = undefined
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new CartUpdateModel(), obj)

    newObj.agencyMasterIds = obj.agencyMasters?.map((i) => i.id)
    newObj.salesPolicyIds = obj.salesPolicies?.map((i) => i.id)

    return newObj
  }

  public static assigns(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}

export class CartConfifUpdateModel {
  id: any
  constructor() {
    this.id = undefined
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new CartConfifUpdateModel(), obj)

    newObj.cartUserManagerIds = obj.cartUserManagers?.map((i) => i.value)

    return newObj
  }

  public static assigns(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}
